import type { FC } from 'react';

import type { Country } from '@shared/info-api';

import type { Address } from '../ContactTypes';
import { getAddressParts } from '../AddressesService';

interface Props {
    address?: Omit<Address, 'id'>;
    countries: Country[];
}

export const FormattedAddress: FC<Props> = ({ address, countries }) => {
    if (!address) {
        return null;
    }

    const addressParts = getAddressParts(address, countries);

    return addressParts.map((part) => <div key={part}>{part}</div>);
};
